<template>
  <div class="TermsText" id="Cookies-policy" v-html="cookies"> </div>
</template>

<script>
export default {
  name: "Cookies",
  data() {
    return {
      cookies: "",
    };
  },
  async mounted() {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        this.cookies = xhttp.responseText
          .replace("{", "")
          .replace('"body":"', "")
          .replace('";', "")
          .replace("}", "")
          .replace("}", "");
      }
    };
    xhttp.open(
      "GET",
      "https://api-mx-marketing.azure-api.net/sitios/cookies/aviso/V2" +
        "?ref=" +
        Math.random() * 9999,
      true,
    );
    xhttp.send();
  },
};
</script>

<style lang="css">
    .TermsText{
        margin-bottom: 30px;
        padding: 160px 30px 60px;
        max-width: 960px;
        margin: 0 auto;
        color: WHITE;
    }
    .TermsText > div > table {
        width: 100%!important;
        border-collapse: collapse!important;
        border-collapse: collapse;
        border-spacing: 0;
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
        box-sizing: border-box;
      margin: 2.5rem 0;
      overflow: auto;
       padding: 1rem
    }

    .TermsText th, td, tr {
        border: 1px solid;
        font-size: 1.2vw!important;
        padding: 5px;
    }

    .TermsText h2,h3,p {
      margin: 0;
    }

    .TermsText h2,h3 {
      text-transform: uppercase;
    }

     .TermsText h2 {
      font-size: 40px;
      font-weight: 900;
      line-height: 1.2em;
      margin-bottom: 1em;
      color: WESTAR;
    }

     .TermsText h3 {
      letter-spacing: 0.1em;
    }

    .TermsText p {
      margin-bottom: 1.5em;
      font-size: 19px;
    }

  </style>

